import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { DetailSection } from './DetailSection';
import { getSonarObjectTypeLabel } from '@sonar-software/sonar-ts-lib';
import { useSonarObjectReference } from '@hooks';
import React from 'react';
function getTitle(type) {
    const typeLabel = type ? getSonarObjectTypeLabel(type) : undefined;
    return typeLabel ? `${typeLabel} ${COPY_GENERIC.INFORMATION}` : COPY_GENERIC.INFORMATION;
}
export const InformationSection = ({ children, headerAction, sonarObjectId }) => {
    const { sonarObjectType } = useSonarObjectReference(sonarObjectId);
    return (React.createElement(DetailSection, { headerAction: headerAction, title: getTitle(sonarObjectType) }, children));
};
